import { render, staticRenderFns } from "./tab-hibah-client.vue?vue&type=template&id=01a2bd3b&"
import script from "./tab-hibah-client.vue?vue&type=script&lang=js&"
export * from "./tab-hibah-client.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports